// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"b95dbdec","581":"3b21fa16","787":"a05eb838","829":"f882fd52","913":"5b360d63"}[chunkId] + ".chunk.js";
};